<script>
import { mapStates } from "element-ui/packages/table/src/store/helper";
import { getColumnWidthStyle, getColumnClasses, isFunction } from "./utils.js";

export default {
  name: "GtTableBody",

  render(h) {
    const data = this.data;

    return h(
      "div",

      {
        class: "gt-table__body"
      },

      data.map((row, rowIndex) => {
        return h(
          "div",

          {
            class: "gt-table__row"
          },

          [
            this.rowHeaderRender(h, row, rowIndex), // render row header
            this.rowTableRender(h, row, rowIndex), // render row table
            this.rowFooterRender(h, row, rowIndex) // render row footer
          ]
        );
      })
    );
  },

  props: {
    store: {
      required: true
    }
  },

  data() {
    return {};
  },

  computed: {
    ...mapStates({
      data: "data",
      columns: "columns"
    }),

    owner() {
      return this.$parent;
    }
  },

  watch: {},

  methods: {
    rowHeaderRender(h, row, rowIndex) {
      const rowHeaderRender = this.owner.$scopedSlots.rowHeader;

      if (!rowHeaderRender) return undefined;

      let rowHeaderVisibleCondition = this.owner.rowHeaderVisibleCondition;

      // rowHeaderVisibleCondition 可能为一个函数 也有可能为一个布尔值
      // rowHeaderVisibleCondition 执行后不可以返回一个 Promise
      if (isFunction(rowHeaderVisibleCondition)) {
        rowHeaderVisibleCondition = rowHeaderVisibleCondition(row, rowIndex);
      }
      // 如果是规则以外的类型 默认返回 true
      else if (typeof rowHeaderVisibleCondition !== "boolean") {
        rowHeaderVisibleCondition = true;
      }

      if (!rowHeaderVisibleCondition) return undefined;

      return h(
        "div",
        { class: "gt-table__row-header" },
        rowHeaderRender({ row, $index: rowIndex })
      );
    },

    rowTableRender(h, row, rowIndex) {
      const columns = this.columns;
      return h(
        "div",
        {
          class: "gt-table__row-body"
        },
        columns.map((column, columnIndex) => {
          return h(
            "div",
            {
              class: [
                "gt-table__row-column",
                ...getColumnClasses({
                  column,
                  columnIndex
                })
              ],
              style: {
                ...getColumnWidthStyle(column)
              }
            },
            [
              h(
                "div",

                {
                  class: "cell"
                },

                [
                  column.renderCell(h, {
                    column,
                    columnIndex,
                    row,
                    store: this.store,
                    $index: rowIndex
                  })
                ]
              )
            ]
          );
        })
      );
    },

    rowFooterRender(h, row, rowIndex) {
      const rowFooterRender = this.owner.$scopedSlots.rowFooter;

      if (!rowFooterRender) return undefined;

      let renderConfition = this.owner.rowFooterVisibleCondition;

      // renderConfition 可能为一个函数 也有可能为一个布尔值
      if (isFunction(renderConfition)) {
        renderConfition = renderConfition(row, rowIndex);
      }
      // 如果是规则以外的类型 默认返回 true
      else if (typeof renderConfition !== "boolean") {
        renderConfition = true;
      }

      if (!renderConfition) return undefined;

      return h(
        "div",
        { class: "gt-table__row-footer" },
        rowFooterRender({ row, $index: rowIndex })
      );
    }
  },

  mounted() {}
};
</script>
